import React, { useEffect, useState, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initializeAuth } from "./store/thunks/authThunks";

// Layouts and Route Protection
import PrivateRoute from "./components/shared/PrivateRoute";
import ErrorBoundary from "./components/shared/ErrorBoundary";

// Auth Components
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import Profile from "./components/auth/Profile";

// Main Components
import Dashboard from "./components/dashboard/Dashboard";
import Users from "./components/users/Users";
import Projects from "./components/projects/Projects";
import UserDetail from "./components/users/UserDetailPage";
import Waitlist from "./components/waitlist/Waitlist";

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#B85C38]"></div>
  </div>
);

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        await dispatch(initializeAuth());
      } catch (error) {
        console.error("Initialization error:", error);
      } finally {
        setIsInitializing(false);
      }
    };

    initialize();
  }, [dispatch]);

  // Show loading spinner during initial auth check
  if (isInitializing) {
    return <LoadingSpinner />;
  }

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/" /> : <Login />}
          />
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/register" /> : <Register />}
          />
          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route
              path="/"
              element={
                <ErrorBoundary>
                  <Dashboard />
                </ErrorBoundary>
              }
            />
            <Route
              path="/profile"
              element={
                <ErrorBoundary>
                  <Profile />
                </ErrorBoundary>
              }
            />
            <Route
              path="/users"
              element={
                <ErrorBoundary>
                  <Users />
                </ErrorBoundary>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <ErrorBoundary>
                  <UserDetail />
                </ErrorBoundary>
              }
            />
            {/* <Route path="/projects" element={
              <ErrorBoundary>
                <Projects />
              </ErrorBoundary>
            } /> */}
            <Route
              path="/waitlist"
              element={
                <ErrorBoundary>
                  <Waitlist />
                </ErrorBoundary>
              }
            />
          </Route>
          {/* Fallback Route */}
          <Route
            path="*"
            element={<Navigate to={isAuthenticated ? "/" : "/login"} />}
          />{" "}
          <Route
            path="/register"
            element={isAuthenticated ? <Navigate to="/" /> : <Register />}
          />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
